export default "__VITE_ASSET__qgspy4nN__"